import { useCurrentMonthCloudSpend } from "../../../Customer/db";
import { useAmountInFormattedCurrency } from "../AmountInCustomerCurrency";
import { useOnNumberClick } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { TopCard } from "../TopCard";

export const CurrentMonthSpendCard = () => {
  const currentSpend = useCurrentMonthCloudSpend();
  const { id, number, trend, trendDirection, monthOffset } = currentSpend;

  const { onNumberClick } = useOnNumberClick();

  const convertedNumber = useAmountInFormattedCurrency(Math.abs(Math.round(monthOffset ?? 0)));

  if (!currentSpend.trendDirection) {
    return <LoadingCard title="Current month spend" />;
  }

  const trendStr = trend
    ? `${trendDirection === "up" ? "Up" : "Down"} ${Number.isInteger(trend) ? Math.abs(trend) : Math.abs(trend).toFixed(2)}% or ${convertedNumber} vs last month`
    : "";

  return (
    <TopCard
      title="Current month spend"
      value={number}
      trend={trendStr}
      trendColor={trendDirection === "up" ? "error.main" : "success.main"}
      dataIcon={trendDirection === "up" ? "trending up" : "trending down"}
      buttonText="Review spend"
      items={[
        {
          title: "Review spend",
          onClick: () => onNumberClick(id),
          eventName: "Review spend",
          description: "Review spend",
        },
        {
          title: "View full dashboard",
          path: "./dashboards/Pulse",
          eventName: "View full dashboard",
          description: "View full dashboard",
        },
      ]}
    />
  );
};
